import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const labelHtmlMapper = (label, index) => {
    if (!label) {
        return ''
    }

    if (label.type === 'image') {
        const relatedMediaId = escapePrintViewText(label.related_media_id || '')

        return `<p>Label ${index + 1} =&gt; image media id: ${relatedMediaId}</p>`
    }

    const labelText = escapePrintViewText(label.text || '')

    if (!labelText) {
        return ''
    }

    return `<p>Label ${index + 1} =&gt; ${labelText}</p>`
}

const buildLabelingQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const backgroundImageMediaId = escapePrintViewText(
        content.image && content.image.related_media_id ? content.image.related_media_id : ''
    )
    const backgroundImageHtml = backgroundImageMediaId
        ? `<p>background image media id: ${backgroundImageMediaId}</p>`
        : ''
    const labelsHtml = (content.labels || [])
        .map((label, index) => labelHtmlMapper(label, index))
        .filter(Boolean)
        .join('')
    const cluesSectionHtml = labelsHtml ? `<p>&nbsp;</p><p>Clues:</p>${labelsHtml}` : ''
    const incorrectCluesHtml = (content.incorrect_clues || [])
        .map((clue, index) => labelHtmlMapper(clue, index))
        .filter(Boolean)
        .join('')
    const incorrectCluesSectionHtml = incorrectCluesHtml
        ? `<p>&nbsp;</p><p>Incorrect Clues:</p>${incorrectCluesHtml}`
        : ''

    return `${questionHtml}${backgroundImageHtml}${cluesSectionHtml}${incorrectCluesSectionHtml}`
}

export {buildLabelingQuestionPrintView}
